import { useState } from "react";
import CouponStyle from "../Coupon/CouponStyle.module.scss";
import { CircularProgress, Grid2 } from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import DangerousIcon from "@mui/icons-material/Dangerous";

const CouponCode = (props) => {
  const {
    onApplyCoupon,
    coupon,
    setCoupon,
    isCouponLoading,
    validCoupon,
    showInput,
    setShowInput,
  } = props;

  const [isEdited, setIsEdited] = useState(false);

  const handleAddCouponClick = () => {
    setShowInput(true);
  };

  const handleInputChange = (e) => {
    setCoupon(e.target.value);
    setIsEdited(true);
  };

  const handleApplyCoupon = () => {
    onApplyCoupon();
    setIsEdited(false);
  };

  const shouldShowIcon = !isEdited;

  return (
    <Grid2>
      <Grid2>
        {!showInput ? (
          <Grid2
            onClick={handleAddCouponClick}
            className={CouponStyle.AddCoupon}
          >
            Add Coupon Code
          </Grid2>
        ) : (
          <>
            <Grid2 className={CouponStyle.flex}>
              <input
                type="text"
                placeholder="Enter coupon code"
                value={coupon}
                onChange={handleInputChange}
                className={`${CouponStyle.styledInput} ${
                  validCoupon?.validity === true && !isEdited
                    ? CouponStyle.color
                    : validCoupon?.validity === false && !isEdited
                    ? CouponStyle.color1
                    : ""
                }`}
              />
              <Grid2 className={CouponStyle.position}>
                {!isCouponLoading &&
                shouldShowIcon &&
                validCoupon?.validity === true ? (
                  <VerifiedIcon className={CouponStyle.verifiedIcon} />
                ) : !isCouponLoading &&
                  shouldShowIcon &&
                  validCoupon?.validity === false ? (
                  <DangerousIcon className={CouponStyle.DangerousIcon} />
                ) : null}
              </Grid2>
              {coupon?.trim() && (
                <Grid2
                  onClick={handleApplyCoupon}
                  className={CouponStyle.apply}
                >
                  {isCouponLoading ? (
                    <CircularProgress size={18} color={"inherit"} />
                  ) : (
                    "Apply"
                  )}
                </Grid2>
              )}
            </Grid2>
            <Grid2 className={CouponStyle.errorText}>
              {!isCouponLoading &&
              shouldShowIcon &&
              validCoupon?.validity === false
                ? "Invalid or already used coupon code"
                : null}
            </Grid2>
          </>
        )}
      </Grid2>
    </Grid2>
  );
};

export default CouponCode;
